/**
 * SessionsSurface — /prioritization/sessions.
 *
 * Renders the Session List (EventsAndSessionsPage). This is the list half of the
 * same List → Detail pair the rest of the product uses: Item List → Item Detail,
 * Session List → Session Detail.
 *
 * The Simple/Advanced toggle was removed 2026-08-27 (DEP-027). It offered two
 * projections of identical data with no rule for when to prefer either, and the
 * choice stuck per-user in localStorage, so two people looking at "the sessions
 * page" saw different products.
 *
 * The Simple view (SessionDashboard, C Mode) is deliberately NOT deleted — it is
 * where the design is heading, it just isn't ready to be the list yet. It still
 * ships as the standalone participant app at /sessions.
 */

import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import EventsAndSessionsPage from './EventsAndSessionsPage';
import { useSessionStore } from '../../../stores/prioritization/sessionStore';
import { sessionPrefillFromConfigurationHandoff } from '../../../lib/sessionPrefill';

export default function SessionsSurface() {
  const fetchFromSupabase = useSessionStore((s) => s.fetchFromSupabase);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // The configuration picker hands off here with ?context_id=…&recommended_tools=…
  // &autolaunch=1. Go straight on to the Event Designer with the context and the
  // recommended tools, instead of dropping them on the list.
  useEffect(() => {
    if (searchParams.get('autolaunch') !== '1') return;
    const prefill = sessionPrefillFromConfigurationHandoff(searchParams);
    if (!prefill) return;
    navigate('/prioritization/sessions/new', { replace: true, state: { prefill } });
  }, [searchParams, navigate]);

  // The list hydrates itself, but a direct link or refresh should not land on an
  // empty page while the store is cold.
  useEffect(() => {
    void fetchFromSupabase();
  }, [fetchFromSupabase]);

  return (
    <div className="flex flex-col min-h-0 flex-1">
      <EventsAndSessionsPage />
    </div>
  );
}
